import {lazy} from 'react';
import {RouteObject, Navigate} from 'react-router-dom';

// const Login = lazy(/* webpackChunkName: "demo" */ () => import('@/pages/user/index'));
const Login = lazy(/* webpackChunkName: "demo" */ () => import('@/pages/user/login'));
// const Register = lazy(/* webpackChunkName: "demo" */ () => import('@/pages/user/Register'));
// const RegisterQrcode = lazy(/* webpackChunkName: "demo" */ () => import('@/pages/user/Register/qrcode'));
// const Forgot = lazy(/* webpackChunkName: "demo" */ () => import('@/pages/user/Forgot'));
const Middle = lazy(/* webpackChunkName: "user" */ () => import('@/pages/user/middle'));
const Feedback = lazy(/* webpackChunkName: "user" */ () => import('@/pages/Feedback/index'));

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <Navigate to={'/individual/private/feedback'} />,
    },
    {
        path: '/individual/private',
        children: [
            {
                path: 'feedback',
                element: <Feedback />,
            },
        ],
    },
    {
        path: '/individual/private/dep2nd/callback/login',
        element: <Login />,
    },
    {
        path: '/individual/private/ngd/callback/login',
        element: <Login />,
    },
    {
        path: '/individual/private/dep2nd/middle/page',
        element: <Middle />,
    },
    {
        path: '/individual/private/ngd/middle/page',
        element: <Middle />,
    },
];
